import styled from 'styled-components';
import { Button } from 'components/common';

export const ButtonStyled = styled(Button)`
  padding: 0px;
  height: 30px;
  width: 55px;
`;
